module.exports = __webpack_public_path__ + "img/1-5.8e5d2565.png";